<script lang="ts">
import { parseInt } from 'lodash-es';

import { useNotify, useToast } from '@viamrobotics/prime-core';

import {
  createDeleteTryReservationMutation,
  createExtendTryReservationMutation,
  createGetActiveTryReservationQuery,
} from '$lib/api/try';

import ActiveTryLinks from './active-try-links.svelte';
import ActiveTryMenus from './active-try-menus.svelte';

const notify = useNotify();
const toast = useToast();
const extendMutation = createExtendTryReservationMutation();
const deleteMutation = createDeleteTryReservationMutation();
const activeReservationQuery = createGetActiveTryReservationQuery();

$: reservation = $activeReservationQuery.data?.reservation;
$: timeRemaining = parseInt(reservation?.secondsRemaining ?? '0', 10);
$: canExtend = Boolean(reservation?.allowedToExtend);
$: canCancel = Boolean(reservation?.allowedToCancel);

const extendReservation = () => {
  if (!reservation) {
    return;
  }

  if (!canExtend) {
    notify.danger('Not allowed to extend the reservation');
    return;
  }

  $extendMutation.mutate(
    { id: reservation.id },
    {
      onSuccess: () =>
        toast({
          message: 'Time extended!',
          variant: 'success',
        }),
      onError: () => notify.danger('Could not extend your reservation'),
    }
  );
};

const cancelReservation = () => {
  if (!reservation) {
    return;
  }

  if (!canCancel) {
    notify.danger('Not allowed to cancel the reservation');
    return;
  }

  $deleteMutation.mutate(
    { id: reservation.id },
    {
      onSuccess: () =>
        toast({
          message: 'Reservation canceled!',
          variant: 'success',
        }),
      onError: () => notify.danger('Could not cancel your reservation'),
    }
  );
};
</script>

{#if reservation && timeRemaining > 0}
  <div
    class="sticky top-0 flex h-10 w-full items-center border-y border-[#4E4F52] bg-[#282829] px-2 text-white"
  >
    <div class="flex h-full w-full items-center justify-start gap-2 text-sm">
      <ActiveTryLinks
        robotID={reservation.robotId}
        robotName={reservation.robotName}
        {timeRemaining}
      />

      <ActiveTryMenus
        onExtend={extendReservation}
        onCancel={cancelReservation}
      />
    </div>
  </div>
{/if}
